import { useState } from 'react';
import styles from './OptionSelector.module.scss'
import BaseContextMenu from '@components/ContextMenu/BaseContextMenu'

interface Options {
  label : string,
  value : number,
}

interface Props{
  options? : Options[];
  value? : number;
  onChange?: (value : number) => void;
  disabled? : boolean;
  className? : string;
  isRow? : boolean;
}

function OptionSelector({
  options,
  value,
  onChange,
  disabled = false,
  className,
  isRow = true
}: Props): React.JSX.Element {
  const [open, setOpen] = useState(false);

  const openContextMenu = () => {
    // if(disabled) return;
    setOpen(true);
  }

  const onClose = () => {
    setOpen(false);
  }

  const handleSelect = (val : number) => {
    onChange?.(val);
    // setOpen(false)
  }

  return (
    <>
      <div
        onClick={openContextMenu}
        // className={`${styles['Option-Default']} ${className ?? ''} ${disabled ? '' : styles.optionColor} ${
        className={`${styles['Option-Default']} ${className ?? ''} ${open ? styles.open : ''}`}
      >
        {options?.find((opt) => opt.value === value)?.label ?? ''}
      </div>
      {(open && options && (
        <BaseContextMenu
          additionalClassName={styles['Option-ContextMenu']}
          onClose={onClose}
        >
          <div
            className={`${styles['Menu-Box']}`}
            // className={`${styles['Menu-Box']} ${isRow ? styles.FlexWrapRow : styles.FlexColumn}`}
          >
            {options.map((opt) => (
              <div
                className={`${styles['Menu-Item']} ${
                  opt.value === value ? styles.activeItem : styles.item
                }`}
                onClick={() => handleSelect(opt.value)}
                key={opt.value}
              >
                {opt.label}
              </div>
            ))}
          </div>
        </BaseContextMenu>
      ))}
    </>
  )
}

export default OptionSelector

